const styles = {
    clearIcon: {
        color: "im_dark_blue.500",
    },
    insertConfigSection: { display: "flex", columnGap: "5px" },
    tableRecordCountSection: { p: "16px" },
};

export default styles;
